import React from 'react';
import { useHistory } from 'react-router-dom';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import ProposalInfoSection from 'components/common/proposal/ProposalInfoSection';
import { toJS } from 'mobx';
import ActionModal from 'components/common/modals/ActionModal';
import { Tools } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRFQProposalPageType } from 'global/hooks/useRFQProposalPageType';
import { Button } from '@insurancemenu/imenu-components-lib';
import { createStyles } from './styles';

const RFQInfoPanel: React.FC = observer(() => {
  const classes = createStyles();

  const history = useHistory();
  const rfqPageType = useRFQProposalPageType();

  const {
    proposalItemsStore: { group, proposal, cart, enrollmentPeriod, catalog },
  } = useRootStore();

  const [showFailingModal, setShowFailingModal] = React.useState(false);
  const convertedProposal = toJS(proposal);

  const proposalPanelInfo = {
    'Agent of Record': group.agentOfRecord?.name || '',
    'Effective Date':
      enrollmentPeriod && dateFormatters.normDateToShortAmericanDate(cart.lastUpdateBrowsingCriteria.effectiveDate),
    Location: `${cart.lastUpdateBrowsingCriteria.county}, ${cart.lastUpdateBrowsingCriteria.state} ${cart.lastUpdateBrowsingCriteria.zipCode}`,
    'Created On': proposal?.createdOn ? dateFormatters.normDateToShortAmericanDate(proposal.createdOn) : '',
    'Created By': proposal?.createdBy?.name || '',
    'Last modified':
      cart.lastUpdateTime?.length > 0 ? dateFormatters.normDateToAmericanDateTime(cart.lastUpdateTime) : '',
  };

  function onGenerateProposal(): void {
    history.push(
      `/generate-proposal/choose-the-way/${enrollmentPeriod.id}?cartId=${proposal.cartId}&groupId=${enrollmentPeriod.groupId}&catalogId=${catalog.id}&proposalType=RFQ`,
    );
  }

  return (
    <section className={classes.mainInfoPanel}>
      <ProposalInfoSection
        title={convertedProposal && convertedProposal.name}
        mainInfo={proposalPanelInfo}
        actions={
          rfqPageType === 'RELEASE' && (
            <Button type="text" uppercase color="primary" leftIconProp={<Tools />} onClick={onGenerateProposal}>
              Generate Proposal
            </Button>
          )
        }
      />
      <ActionModal
        show={showFailingModal}
        onClose={(): void => {
          setShowFailingModal(false);
        }}
        title="Something went wrong, please try again"
        subtitle={
          <p>
            If you still have issues, please send an email to <br />
            <a href="mailto:support@insurancemenu.com">support@insurancemenu.com</a>
          </p>
        }
      />
    </section>
  );
});

export default RFQInfoPanel;
